//const PROJECTID = "8FNAiM6MoeYu7HoBrCW5"
const PROJECTID = "HR19rr0ZLH8fCrOtxq7R"
export default {
    PROJECTID: PROJECTID
}

// var firebaseConfig = {
//     apiKey: "AIzaSyBocYLbMEuUhJdjAx8guIP89J-yrGtMgpM",
//     authDomain: "iventure-v1.firebaseapp.com",
//     databaseURL: "https://iventure-v1.firebaseio.com",
//     projectId: "iventure-v1",
//     storageBucket: "iventure-v1.appspot.com",
//     messagingSenderId: "536766960981",
//     appId: "1:536766960981:web:8191048bbaef0d4b"
//   };
//   // Initialize Firebase
//   firebase.initializeApp(firebaseConfig);
//   const db = firebase.firestore();

//   export default db;